import React from "react";
import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils";

export const DollarIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge("size-5", className)}
      {...props}
    >
      <path
        d="M12.75 6C12.75 4.34315 11.4069 3 9.75 3H8.25C6.59315 3 5.25 4.34315 5.25 6C5.25 7.65685 6.59315 9 8.25 9H9.75C11.4069 9 12.75 10.3431 12.75 12C12.75 13.6569 11.4069 15 9.75 15H8.25C6.59315 15 5.25 13.6569 5.25 12M9 1.5L9 16.5"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
      />
    </svg>
  );
};
